export const TYPE_COMPANY = 1
export const TYPE_IMPORT = 3
